import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface HiringManagerCheckboxProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled: boolean;
}

export default function HiringManagerCheckbox({
  value,
  onChange,
  disabled,
}: HiringManagerCheckboxProps) {
  const { t } = useTranslation();

  return (
    <FormControlLabel
      control={
        <Checkbox
          id='hiring-manager-checkbox'
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
      }
      label={t('formInputs.hiringManagerInputLabel')}
    />
  );
}
